module.exports = __webpack_public_path__ + "media/fonts/LearningCurve-7f4436a6becb6606dee1e49b6d5cffe9.woff";